import React, {useState, useEffect} from 'react';
import Loading from 'components/Loading'
import MainLayout from 'newComponents/Layout/MainLayout';
import CreditoLayout from 'newComponents/Layout/CreaditoLayout';
import SolicitarEstadoCuenta from './Estados';
import { useEstadoCuenta } from 'newHooks/useEstadoDeCuenta';
import { ModalTarjetaDigital } from 'newComponents/Modals';
import ModalPortal from 'newComponents/ModalGlobal';

export default function EstadoCuenta() {
    const [ data, setData ] = useState()
    const { loading, setPeriod, errorCode, showInfoModal, infoModalMessage, handleCloseInfoModal } = useEstadoCuenta()

    //- Codigo de instana para track de pagina 
    useEffect(()=>{
        // window.ineum('page', 'Bank Statement Credit-Page')
        // window.ineum('meta', 'portal', 'Credito')
    },[])

    return (
        <MainLayout>
            <CreditoLayout setData={setData} >
                { loading && <Loading /> }
                <SolicitarEstadoCuenta setPeriod={setPeriod} errorCode={errorCode} loading={loading}/>
                {showInfoModal && (
                    <ModalPortal type="modalSB" onClose={handleCloseInfoModal} >
                        <ModalTarjetaDigital 
                            remvoeAction={handleCloseInfoModal}
                            title="Información"
                            body={infoModalMessage}
                        />
                    </ModalPortal>
                )}
            </CreditoLayout>
        </MainLayout>
    )
}